var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import moment from "moment";
import opsgenieTeamsQuery from "./opsgenieTeams.query.graphql";
import serviceOverviewQuery from "./service-overview.query.graphql";
import categoriesQuery from "./categories.query.graphql";
import updateServiceMutation from "./update-service.mutation.graphql";
import addCategoryMutation from "./add-category.mutation.graphql";
import removeCategoryMutation from "./remove-category.mutation.graphql";
import styled from "styled-components";
import { SERVICE_TIERS } from "./slo";
import { DeleteServiceModal } from "./delete-service-modal";
import { Link, GrayText, withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, EditablePage, EditableTextArea, EditableTextField, withServiceNotFoundHandler, displayUserInfo, Grid, GridColumn, EditableSelect, EditableQuerySelect, EditableCreatableSelect, isSufficientPermission, getErrorMessage, withFeatureFlags, withAnalytics, userUrl, openExternalLink, compose, graphql, Card } from "@atlassiansox/microscopekit";
import { Permission } from "../../__generated__/graphql-global-types";
import { get } from "lodash";
import { Tc2Error, shouldShowTc2Error } from "./tc2";
var Field = require("@atlaskit/form").Field;
var AkTag = require("@atlaskit/tag").default;
var AkTagGroup = require("@atlaskit/tag-group").default;
var AkButtonGroup = require("@atlaskit/button").ButtonGroup;
var SSAMBaseUrl = "https://ssam.prod.atl-paas.net/access/containers/";
var OpsgenieBaseUrl = function (id) {
    return "https://atlassian.app.opsgenie.com/teams/dashboard/" + id;
};
export var BorderlessTable = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-collapse: initial;\n  padding-top: 1em;\n"], ["\n  border-collapse: initial;\n  padding-top: 1em;\n"])));
BorderlessTable.displayName = "BorderlessTable";
export var TextLink = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
function mapNetworkSegment(segment) {
    var segmentMap = new Map([
        ['atl', 'Atlassian Internal'],
        ['customer', 'Customer'],
        ['dmz', 'DMZ'],
        ['cicd', 'CI/CD']
    ]);
    var res = segmentMap.get(segment);
    if (!res) {
        res = segment;
    }
    return res;
}
function stripHashFromSlackChannel(channel) {
    if (channel === undefined) {
        return undefined;
    }
    if (channel.startsWith('#')) {
        return channel.substr(1);
    }
    return channel;
}
var getIsChromeless = function () { return window.sessionStorage.getItem("chromeless") === "1"; };
var ServiceOverviewView = /** @class */ (function (_super) {
    __extends(ServiceOverviewView, _super);
    function ServiceOverviewView(props) {
        var _this = _super.call(this, props) || this;
        _this.updateCategories = function (categories) { return __awaiter(_this, void 0, void 0, function () {
            var currentCategories, toAdd, toRemove, serviceId;
            var _this = this;
            return __generator(this, function (_a) {
                currentCategories = this.props.data.service.categories.map(function (category) { return category.id; });
                toAdd = categories.filter(function (category) { return !currentCategories.includes(category); });
                toRemove = currentCategories.filter(function (category) { return !categories.includes(category); });
                serviceId = this.props.data.service.metadata.serviceUUID;
                return [2 /*return*/, Promise.all(toAdd.map(function (categoryId) {
                        return _this.props.addServiceToCategory({
                            variables: {
                                serviceId: serviceId,
                                categoryId: categoryId
                            }
                        });
                    }).concat(toRemove.map(function (categoryId) {
                        return _this.props.removeServiceFromCategory({
                            variables: {
                                serviceId: serviceId,
                                categoryId: categoryId
                            }
                        });
                    })))];
            });
        }); };
        _this.queryCategories = function (input, query) { return __awaiter(_this, void 0, void 0, function () {
            var result, categories, leaves, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!input) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, query({
                                query: categoriesQuery,
                                variables: {
                                    query: input
                                },
                                context: {
                                    debounceKey: "CategoriesQuery"
                                }
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.data && result.data.categories) {
                            categories = result.data.categories;
                            leaves = categories.filter(function (category) { return !isNaN(parseInt(category.id, 10)); });
                            options = leaves.map(function (category) { return ({
                                label: category.name,
                                value: category.name
                            }); });
                            return [2 /*return*/, options];
                        }
                        else if (result.errors) {
                            this.props.showFlag({
                                type: "error",
                                title: "Failed to fetch list of categories",
                                message: getErrorMessage(result.errors)
                            });
                        }
                        return [2 /*return*/, []];
                }
            });
        }); };
        _this.queryOpsgenieTeams = function (input, query) { return __awaiter(_this, void 0, void 0, function () {
            var result, opsgenieTeams, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!input) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, query({
                                query: opsgenieTeamsQuery,
                                variables: {
                                    query: input
                                },
                                context: {
                                    debounceKey: "OpsgenieTeamsQuery"
                                }
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.data && result.data.opsgenieTeams) {
                            opsgenieTeams = result.data.opsgenieTeams;
                            options = opsgenieTeams.map(function (opsgenieTeam) { return ({
                                label: opsgenieTeam.team,
                                value: opsgenieTeam.team,
                                id: opsgenieTeam.id
                            }); });
                            return [2 /*return*/, options];
                        }
                        else if (result.errors) {
                            this.props.showFlag({
                                type: "error",
                                title: "Failed to fetch list of Opsgenie Teams",
                                message: getErrorMessage(result.errors)
                            });
                        }
                        return [2 /*return*/, []];
                }
            });
        }); };
        _this.onSave = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var service, id, segmentPayload, serviceTier, zeroDowntimeUpgrades, metadata, opsgenieEtag, networkSegmentEtag, e_1, errMsg, errComponent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        service = this.props.data.service;
                        id = service.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        serviceTier = data.serviceTier;
                        zeroDowntimeUpgrades = data.zeroDowntimeUpgrades;
                        metadata = {
                            businessUnit: data.businessUnit,
                            description: data.description,
                            hipchatRoomName: data.hipchatRoomName,
                            location: data.location,
                            loggingID: typeof data.loggingID == "string" ? data.loggingID.trim() : data.loggingID,
                            platform: data.platform,
                            servingURL: data.servingURL,
                            ssamContainerName: data.ssamContainerName,
                            team: data.team,
                            zeroDowntimeUpgrades: zeroDowntimeUpgrades && zeroDowntimeUpgrades.value,
                            serviceTier: serviceTier && serviceTier.value,
                            publicFacing: data.publicFacing && data.publicFacing.value,
                            thirdPartyProvided: data.thirdPartyProvided && data.thirdPartyProvided.value,
                            stateless: data.stateless && data.stateless.value
                        };
                        opsgenieEtag = get(this.props.data, "service.attributes.opsgenieAttribute.etag");
                        networkSegmentEtag = get(this.props.data, "service.attributes.microsNetworkSegmentAttribute.etag");
                        if (!data.networkSegment || !service.attributes.microsNetworkSegmentAttribute || !service.attributes.microsNetworkSegmentAttribute.value) {
                            // if network segment data does not exist
                            segmentPayload = {
                                value: null,
                                etag: networkSegmentEtag
                            };
                        }
                        else if (data.networkSegment.value !== service.attributes.microsNetworkSegmentAttribute.value.networkSegment) {
                            // if network segment selected
                            segmentPayload = {
                                value: {
                                    networkSegment: data.networkSegment.value,
                                    availableSegments: [],
                                },
                                etag: networkSegmentEtag
                            };
                        }
                        else {
                            // if network segment hasn't changed
                            segmentPayload = {
                                value: {
                                    networkSegment: data.networkSegment.value,
                                    availableSegments: service.attributes.microsNetworkSegmentAttribute && service.attributes.microsNetworkSegmentAttribute.value ? service.attributes.microsNetworkSegmentAttribute.value.availableSegments : [],
                                },
                                etag: networkSegmentEtag
                            };
                        }
                        return [4 /*yield*/, Promise.all([
                                this.updateCategories(data.categories.map(function (category) { return category.value; })),
                                this.props.updateService({
                                    variables: {
                                        input: {
                                            id: id,
                                            metadata: metadata,
                                            tags: data.tags && data.tags.map(function (tag) { return tag.value; }),
                                            attributes: {
                                                opsgenieAttribute: data.opsgenieTeam && data.opsgenieTeam.value
                                                    ? // If opsgenieTeam
                                                        {
                                                            value: {
                                                                team: data.opsgenieTeam.value,
                                                                teamId: data.opsgenieTeam.id
                                                            },
                                                            etag: opsgenieEtag
                                                        }
                                                    : {
                                                        // If no opsgenieTeam
                                                        value: null,
                                                        etag: opsgenieEtag
                                                    },
                                                microsNetworkSegmentAttribute: segmentPayload
                                            }
                                        }
                                    }
                                })
                            ])];
                    case 2:
                        _a.sent();
                        this.props.showFlag({
                            type: "success",
                            title: "Success",
                            message: "Service successfully updated."
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.props.track("ServiceOverview: Update failed", {
                            category: "error",
                            element: "service overview",
                            serviceId: id
                        });
                        errMsg = getErrorMessage(e_1);
                        errComponent = shouldShowTc2Error(errMsg) ? (React.createElement(Tc2Error, { serviceId: id })) : (React.createElement("p", null, errMsg));
                        this.props.showFlag({
                            type: "error",
                            title: "Failed to update service",
                            message: errComponent,
                            disableAutoDismiss: true,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            deleteModalOpen: false
        };
        return _this;
    }
    ServiceOverviewView.prototype.componentDidMount = function () {
        document.title = this.props.data.service.id + " | Overview";
    };
    ServiceOverviewView.prototype.componentWillUnmount = function () {
        document.title = "Microscope";
    };
    ServiceOverviewView.prototype.render = function () {
        var service = this.props.data.service;
        var metadata = service.metadata, attributes = service.attributes;
        var contacts = metadata.contactInfo;
        var segmentInfo = service.attributes.microsNetworkSegmentAttribute;
        var noSSAMSet = !metadata.ssamContainer &&
            isSufficientPermission(service.currentUserPermission, Permission.Write);
        var displayDeleteModal = isSufficientPermission(service.currentUserPermission, Permission.Admin);
        var actions = displayDeleteModal ? (React.createElement(AkButtonGroup, null, displayDeleteModal && React.createElement(DeleteServiceModal, { id: service.id }))) : (undefined);
        return (React.createElement(EditablePage, { title: "Overview", actions: actions, onSave: this.onSave, isEditable: isSufficientPermission(service.currentUserPermission, Permission.Write) },
            getIsChromeless() && (React.createElement(Card, { style: { marginBottom: 20 } },
                React.createElement("p", null, "Service Central is still the source of truth for services at Atlassian. Compass syncs the data from Service Central. You cannot modify data of your services from the Overview page of Compass. This is where you update the Service data and it will be reflected in the Overview page of Compass"))),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement(Field, { label: "Owner", name: "owner" }, function () { return (React.createElement("div", null,
                        React.createElement(Link, { to: userUrl(metadata.owner.id) }, displayUserInfo(metadata.owner)))); }),
                    React.createElement(EditableTextField, { name: "businessUnit", label: "Business Unit", defaultValue: metadata.businessUnit || undefined }),
                    React.createElement(EditableTextField, { name: "location", label: "Location", defaultValue: metadata.location || undefined }),
                    React.createElement(EditableTextField, { name: "platform", label: "Platform", defaultValue: metadata.platform || undefined }),
                    React.createElement(EditableTextField, { name: "servingURL", label: "URL", defaultValue: metadata.servingURL || undefined }),
                    React.createElement(EditableTextField, { name: "ssamContainerName", label: "SSAM Container", defaultValue: (metadata.ssamContainer && metadata.ssamContainer.shortName) ||
                            undefined, url: metadata.ssamContainer &&
                            SSAMBaseUrl + metadata.ssamContainer.shortName, isDisabled: metadata.platform === "micros" ||
                            !isSufficientPermission(service.currentUserPermission, Permission.Admin) }),
                    React.createElement(Field, { label: "UUID", name: "uuid" }, function () { return React.createElement("div", null, metadata.serviceUUID); }),
                    React.createElement(EditableSelect, { name: "networkSegment", label: "Network Segment", placeholder: "Pick a Network Segment", isDisabled: !(segmentInfo && segmentInfo.value && segmentInfo.value.availableSegments && segmentInfo.value.availableSegments.length !== 0), options: segmentInfo && segmentInfo.value && segmentInfo.value.availableSegments ? segmentInfo.value.availableSegments.map(function (networkSegment) { return ({ label: mapNetworkSegment(networkSegment), value: networkSegment }); }) : [], defaultValue: segmentInfo &&
                            segmentInfo.value &&
                            segmentInfo.value.networkSegment
                            ? {
                                label: mapNetworkSegment(segmentInfo.value.networkSegment),
                                value: segmentInfo.value.networkSegment
                            }
                            : undefined })),
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement(EditableSelect, { name: "serviceTier", label: "Service Tier", defaultValue: metadata.sla
                            ? {
                                label: "Tier " + metadata.sla.serviceTier,
                                value: metadata.sla.serviceTier
                            }
                            : undefined, options: SERVICE_TIERS.map(function (t) { return ({
                            label: "Tier " + t,
                            value: t
                        }); }) }),
                    React.createElement(EditableSelect, { name: "publicFacing", label: "Public Facing", defaultValue: {
                            label: metadata.publicFacing ? "Yes" : "No",
                            value: metadata.publicFacing
                        }, options: [
                            {
                                label: "Yes",
                                value: true
                            },
                            {
                                label: "No",
                                value: false
                            }
                        ] }),
                    React.createElement(EditableSelect, { name: "thirdPartyProvided", label: "Third Party Provided", defaultValue: {
                            label: metadata.thirdPartyProvided ? "Yes" : "No",
                            value: metadata.thirdPartyProvided
                        }, options: [
                            {
                                label: "Yes",
                                value: true
                            },
                            {
                                label: "No",
                                value: false
                            }
                        ] }),
                    React.createElement(EditableSelect, { name: "stateless", label: "Stateless", defaultValue: {
                            label: metadata.stateless ? "Yes" : "No",
                            value: metadata.stateless
                        }, options: [
                            {
                                label: "Yes",
                                value: true
                            },
                            {
                                label: "No",
                                value: false
                            }
                        ] }),
                    React.createElement(EditableSelect, { name: "zeroDowntimeUpgrades", label: "Zero Downtime Upgrades", defaultValue: {
                            label: metadata.sla.zeroDowntimeUpgrades ? "Yes" : "No",
                            value: metadata.sla.zeroDowntimeUpgrades
                        }, options: [
                            {
                                label: "Yes",
                                value: true
                            },
                            {
                                label: "No",
                                value: false
                            }
                        ] }),
                    React.createElement(EditableTextField, { name: "loggingID", label: "Logging ID", defaultValue: metadata.loggingID || undefined, isDisabled: true }),
                    React.createElement(Field, { label: "Recovery Point Objective", name: "recoveryPointObjective" }, function () { return (React.createElement("div", null, moment
                        .duration(metadata.sla.recoveryPointObjective * 1000)
                        .humanize())); }),
                    React.createElement(Field, { label: "Recovery Time Objective", name: "recoveryTimeObjective" }, function () { return (React.createElement("div", null, moment
                        .duration(metadata.sla.recoveryTimeObjective * 1000)
                        .humanize())); }))),
            React.createElement("h4", null, "Team Members"),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 12 }, this.props.data.service.metadata.admins &&
                    this.props.data.service.metadata.admins.length > 0 ? (React.createElement(AkTagGroup, null, this.props.data.service.metadata.admins.map(function (admin) {
                    return admin.__typename === "User" ? (React.createElement(AkTag, { key: admin.username, text: React.createElement(Link, { to: userUrl(admin.username) }, displayUserInfo(admin)) })) : (React.createElement(AkTag, { key: admin.groupName, text: admin.displayName }));
                }))) : isSufficientPermission(service.currentUserPermission, Permission.Write) &&
                    !noSSAMSet ? (React.createElement(GrayText, { bold: true },
                    "This service has no team members. The associated SSAM Container may be setup incorrectly. Check out\u00A0",
                    React.createElement(TextLink, { onClick: function () {
                            openExternalLink("http://go/microscope-ssam", "_blank");
                        } }, "go/microscope-ssam"),
                    " ",
                    "\u00A0to find out more.")) : (React.createElement(GrayText, { bold: true }, "None.")))),
            React.createElement("h4", null, "Description"),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 12 },
                    React.createElement(EditableTextArea, { name: "description", minimumRows: 5, defaultValue: metadata.description || undefined }))),
            React.createElement("h4", null, "Contacts"),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement(EditableTextField, { name: "hipchatRoomName", label: "Slack Channel", url: contacts && contacts.hipchatRoomName ? "https://slack.com/app_redirect?channel=" + stripHashFromSlackChannel(contacts.hipchatRoomName) : undefined, defaultValue: (contacts && contacts.hipchatRoomName) || undefined }),
                    React.createElement(EditableQuerySelect, { name: "opsgenieTeam", label: "Opsgenie Team", placeholder: "Search for Opsgenie team...", noOptionsMessage: function () { return "No matches found"; }, loadOptions: this.queryOpsgenieTeams, isClearable: true, defaultValue: attributes.opsgenieAttribute &&
                            attributes.opsgenieAttribute.value &&
                            attributes.opsgenieAttribute.value.team
                            ? {
                                label: attributes.opsgenieAttribute.value.team,
                                value: attributes.opsgenieAttribute.value.team,
                                id: attributes.opsgenieAttribute.value.id
                            }
                            : undefined, url: attributes.opsgenieAttribute &&
                            attributes.opsgenieAttribute.value &&
                            attributes.opsgenieAttribute.value.id
                            ? OpsgenieBaseUrl(attributes.opsgenieAttribute.value.id)
                            : undefined }),
                    React.createElement(EditableTextField, { name: "team", label: "Team Name", defaultValue: (contacts && contacts.team) || undefined }))),
            React.createElement("br", null),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement("h4", null, "Tags"),
                    React.createElement(EditableCreatableSelect, { name: "tags", isMulti: true, defaultValue: (metadata.tags || []).map(function (tag) { return ({
                            label: tag,
                            value: tag,
                            url: "/search/services?query=tags:" + tag
                        }); }) })),
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement("h4", null, "Categories"),
                    React.createElement(EditableQuerySelect, { name: "categories", isMulti: true, loadOptions: this.queryCategories, defaultValue: service.categories.map(function (cat) { return ({
                            label: cat.displayName || cat.name,
                            value: cat.id,
                            url: "/categories/" + cat.id
                        }); }) }))),
            React.createElement("br", null),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 6 },
                    React.createElement(Field, { label: "Created", name: "created" }, function () { return (React.createElement("div", null, metadata.changeMetadata.createdOn
                        ? moment(metadata.changeMetadata.createdOn).fromNow()
                        : "N/A")); }),
                    React.createElement(Field, { label: "Last Modified", name: "lastModified" }, function () { return (React.createElement("div", null, metadata.changeMetadata.modifiedOn
                        ? moment(metadata.changeMetadata.modifiedOn).fromNow()
                        : "N/A")); }),
                    React.createElement(Field, { label: "Last Modified By", name: "lastModifiedBy" }, function () { return (React.createElement("div", null, metadata.changeMetadata.modifiedBy
                        ? metadata.changeMetadata.modifiedBy.id
                        : "N/A")); })))));
    };
    return ServiceOverviewView;
}(React.Component));
export { ServiceOverviewView };
export var ServiceOverviewPage = compose(graphql(updateServiceMutation, {
    name: "updateService"
}), graphql(addCategoryMutation, {
    name: "addServiceToCategory"
}), graphql(removeCategoryMutation, {
    name: "removeServiceFromCategory"
}), graphql(serviceOverviewQuery, {
    options: function () { return ({
        errorPolicy: "all"
    }); }
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withFeatureFlags, withAnalytics)(ServiceOverviewView);
var templateObject_1, templateObject_2;
